// Footer.js
import React from 'react';

const Footer = () => {
  return (
    <div style={{ marginTop: 'auto', textAlign: 'center', backgroundColor: '#f0f0f0', padding: '10px', flexShrink: 0 }}>
      <p>Email: tricksandcodes29@gmail.com | LinkedIn: <a href='https://www.linkedin.com/in/srinivas-gurazala-a30094212/'>www.linkedin.com/in/srinivas-gurazala-a30094212/</a> | GitHub: <a href='https://github.com/vasu-09'>github.com/vasu-09</a></p>
    </div>
  );
}

export default Footer;
